import { Label, List } from '@mairistem/composants';

const PayeurContactListItem = (props) => {
  const { telephone, portable, mail } = props;

  return (
    <>
      <List.Description>
        <Label content={portable} icon="mobile" />
      </List.Description>
      <List.Description>
        <Label content={telephone} icon="phone" />
      </List.Description>
      <List.Description>
        <Label content={mail} icon="mail" />
      </List.Description>
    </>
  );
};

export default PayeurContactListItem;
